export const DEPARTMENTS = [
  "Ancianos",
  "Ministerio Juvenil",
  "Aventureros",
  "Conquistadores",
  "Guías Mayores",
  "Ministerio de Salud",
  "Ministerios Personales",
  "Tesorería",
  "Mayordomía",
  "Publicaciones",
  "Escuela Sabática",
  "Ministerio Infantil",
  "Secretaría",
  "Música",
  "Comunicación",
  "Diáconos",
  "Diaconisas",
  "Ministerio de la Mujer",
];

export const DEFAULT_ROLES = ["Anciano encargado", "Director", "Subdirector", "Secretario"];

export const VISIT_TYPES = [
  { value: "animo", label: "Ánimo" },
  { value: "estudio_biblico", label: "Estudio Bíblico" },
  { value: "disciplina", label: "Disciplina" },
  { value: "general", label: "Visita general" },
];

export const EVENT_TYPES = [
  { value: "culto", label: "Culto" },
  { value: "reunion", label: "Reunión" },
  { value: "predicacion", label: "Predicación" },
  { value: "actividad_especial", label: "Actividad Especial" },
];

export const PERSONAL_EVENT_TYPES = [
  { value: "oracion", label: "Oración" },
  { value: "estudio", label: "Estudio" },
  { value: "familia", label: "Familia" },
  { value: "reunion", label: "Reunión" },
  { value: "actividad", label: "Actividad" },
  { value: "otro", label: "Otro" },
];

export const FAMILY_STATUSES = [
  { value: "frecuente", label: "Frecuente", tone: "green" },
  { value: "no_frecuente", label: "No frecuente", tone: "amber" },
  { value: "a_rescatar", label: "A rescatar", tone: "red" },
  { value: "interesada", label: "Interesada", tone: "blue" },
];

export const SPIRITUAL_STATUSES = [
  { value: "frecuente", label: "Frecuente", tone: "green" },
  { value: "no_frecuente", label: "No frecuente", tone: "amber" },
  { value: "a_rescatar", label: "A rescatar", tone: "red" },
  { value: "interesado", label: "Interesado", tone: "blue" },
];

export const MARITAL_STATUSES = [
  { value: "soltero", label: "Soltero/a" },
  { value: "casado", label: "Casado/a" },
  { value: "viudo", label: "Viudo/a" },
  { value: "divorciado", label: "Divorciado/a" },
  { value: "union_libre", label: "Unión libre" },
  { value: "separado", label: "Separado/a" },
];

export const BAPTISM_STATUSES = [
  { value: "bautizado", label: "Bautizado" },
  { value: "no_bautizado", label: "No bautizado" },
  { value: "rebautizado", label: "Rebautizado" },
  { value: "en_proceso", label: "En proceso" },
];

// Weekly personal agenda template
export const WEEKLY_TEMPLATE = {
  0: "Shabbat", // Saturday
  1: "Clubes", // Sunday
  2: "Iglesia 1", // Monday
  3: "Iglesia 2", // Tuesday
  4: "Iglesia 3", // Wednesday
  5: "Iglesia 4", // Thursday
  6: "Iglesia 5", // Friday
};
// JS getDay(): Sun=0..Sat=6. Build correct mapping:
export const WEEKLY_TEMPLATE_BY_GETDAY = {
  0: "Shabbat", // Saturday
  1: "Clubes", // Sunday
  2: "Iglesia 1", // Monday
  3: "Iglesia 2", // Tuesday
  4: "Iglesia 3", // Wednesday
  5: "Iglesia 4", // Thursday
  6: "Iglesia 5", // Friday
};

export const WEEK_DAYS_ES = [
  { idx: 0, label: "Domingo" },
  { idx: 1, label: "Lunes" },
  { idx: 2, label: "Martes" },
  { idx: 3, label: "Miércoles" },
  { idx: 4, label: "Jueves" },
  { idx: 5, label: "Viernes" },
  { idx: 6, label: "Sábado" },
];

export const PRAYER_CATEGORIES = [
  { value: "salud", label: "Salud", tone: "red" },
  { value: "familia", label: "Familia", tone: "blue" },
  { value: "espiritual", label: "Espiritual", tone: "amber" },
  { value: "financiero", label: "Financiero", tone: "green" },
];

export const USER_STATUSES = [
  { value: "pending", label: "Pendiente", tone: "amber" },
  { value: "approved", label: "Aprobado", tone: "green" },
  { value: "admin", label: "Administrador", tone: "red" },
  { value: "revoked", label: "Revocado", tone: "slate" },
];
